export default "__VITE_ASSET__BJISq6De__"